import { Component } from '@angular/core';

@Component({
	template: `
		<p-confirmDialog class="confirm-dialog" key="close"></p-confirmDialog>
		<p-confirmDialog class="confirm-dialog" [closable]="false" [rejectVisible]="false" key="no-close"></p-confirmDialog>
	`
})
export class PConfirmDialogWrapper {
	constructor() { }
}